import { ModelInputs } from "./types";

export const DEFAULT_INPUTS: ModelInputs = {
  customer_id: "",
  project_name: "",
  latitude: 40.1164,
  longitude: -88.2434,
  state: "CA",
  county: "Orange",
  city: "",
  zip_code: "",
  timezone: "America/Los_Angeles",
  project_nerc_code: "",
  eia_ba_code: "",
  cod_date: "",
  decommision_date: "",
  nameplate_capacity: 100.0,
  poi_limit: "",
  project_additional_load: "",
  ppa_percentage: "",
  ppa_capacity: 100.0,
  battery_capacity_mwh: "",
  battery_charge_rate_mw: "",
  battery_discharge_rate_mw: "",
  battery_round_trip_eff: "",
  battery_soc_min: "",
  battery_chemistry: "lfp",
  battery_calendar_life_years: 20,
  battery_cycle_life: 6000,
  battery_augmentation_flag: false,
  battery_depth_of_discharge: 0.85,
  project_lifetime_years: "",
  existing_project_flag: false,
  sam_profile_flag: true,
  ppa_flag: false,
  battery_flag: false,
  tech_type_id: "solar_ground",
  gen_hour_profile_mw: [],
};
